var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUndo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 5.25H11.25C12.6519 5.25 13.3529 5.25 13.875 5.55145C14.2171 5.74892 14.5011 6.03296 14.6986 6.37499C15 6.89711 15 7.5981 15 9C15 10.4019 15 11.1028 14.6986 11.625C14.5011 11.9671 14.2171 12.2511 13.875 12.4486C13.3529 12.75 12.6519 12.75 11.25 12.75H6.00001M3 5.25L5.25 3M3 5.25L5.25 7.5",
    stroke: "#121212",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndo);
export default __webpack_public_path__ + "static/media/Undo.a64c56fd88b9805ca6e0217438ec6547.svg";
export { ForwardRef as ReactComponent };